import { createBrowserClient } from "@supabase/ssr";

function isValidHttpUrl(s: string | undefined): s is string {
  if (!s) return false;
  try { const u = new URL(s); return u.protocol === "http:" || u.protocol === "https:"; }
  catch { return false; }
}

export function createClient() {
  const url = process.env.NEXT_PUBLIC_SUPABASE_URL;
  const key = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;
  // If env is missing OR a placeholder, return a chainable no-op stub so SSR/CSR
  // don't crash. Real DB calls just resolve to { data: null, error: null }.
  if (!isValidHttpUrl(url) || !key || key.length < 20) {
    const result = Promise.resolve({ data: null, error: null });
    const stub: any = new Proxy(function () {}, {
      get(_t, prop) {
        if (prop === "then") return result.then.bind(result);
        if (prop === "catch") return result.catch.bind(result);
        if (prop === "finally") return result.finally.bind(result);
        if (prop === "auth") return {
          getSession: () => Promise.resolve({ data: { session: null }, error: null }),
          getUser: () => Promise.resolve({ data: { user: null }, error: null }),
          signInWithPassword: () => Promise.resolve({ data: null, error: { message: "Supabase not configured" } }),
          signOut: () => Promise.resolve({ error: null }),
          onAuthStateChange: () => ({ data: { subscription: { unsubscribe() {} } } }),
        };
        return () => stub;
      },
      apply() { return stub; },
    });
    return stub;
  }
  return createBrowserClient(url!, key!);
}
